<dialog *ngIf="showSweetAlert" open class="swal2-container swal2-center swal2-fade swal2-shown">
  <div
    aria-labelledby="swal2-title"
    aria-describedby="swal2-content"
    class="swal2-popup swal2-modal swal2-show"
    tabindex="-1"
    style="display: flex"
  >
    <div class="swal2-header">
      <ul class="swal2-progresssteps" style="display: none"></ul>

      <div
        class="swal2-icon swal2-error swal2-animate-error-icon"
        [style.display]="alertType === 'sweetError' ? 'flex' : 'none'"
      >
        <span class="swal2-x-mark">
          <span class="swal2-x-mark-line-left"></span>
          <span class="swal2-x-mark-line-right"></span>
        </span>
      </div>

      <div
        class="swal2-icon swal2-question"
        [style.display]="alertType === 'sweetQuestion' ? 'flex' : 'none'"
      >
        <span class="swal2-icon-text">?</span>
      </div>

      <div
        class="swal2-icon swal2-warning"
        [style.display]="
          alertType === 'sweetWarning' || alertType === 'sweetConfirm'
            ? 'flex'
            : 'none'
        "
      >
        <span class="swal2-icon-text">!</span>
      </div>

      <div
        class="swal2-icon swal2-info"
        [style.display]="alertType === 'sweetInfo' ? 'flex' : 'none'"
      >
        <span class="swal2-icon-text">i</span>
      </div>

      <div
        class="swal2-icon swal2-success swal2-animate-success-icon"
        [style.display]="alertType === 'sweetSuccess' ? 'flex' : 'none'"
      >
        <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255)"></div>
        <span class="swal2-success-line-tip"></span>
        <span class="swal2-success-line-long"></span>
        <div class="swal2-success-ring"></div>
        <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255)"></div>
        <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255)"></div>
      </div>

      <img
        class="swal2-image"
        src="{{ image }}"
        [style.display]="alertType === 'sweetImageMessage' ? 'flex' : 'none'"
        alt=""
      />

      <h2 class="swal2-title" id="swal2-title" style="display: flex">
        {{ header }}
      </h2>
      <button type="button" class="swal2-close" style="display: none" (click)="rejectButton($event)">×</button>
    </div>

    <div class="swal2-content">
      <div id="swal2-content" style="display: block">{{ message }}</div>

      <!-- input alan component ekleyebilme  -->
      <div [style.display]="alertType === 'sweetInput' ? 'flex' : 'none'">
        <ng-content select="[sweetAlertInput]"></ng-content>
      </div>
    </div>

    <div class="swal2-actions" style="display: flex">
      <button
        type="button"
        class="swal2-cancel swal2-styled"
        [style.display]="alertType === 'sweetConfirm' ? 'inline-block' : 'none'"
        (click)="rejectButton($event)"
      >
        {{ rejectLabel ? rejectLabel : "İptal" }}
      </button>

      <button
        *ngIf="alertType !== 'sweetAutoClose'"
        type="button"
        class="swal2-confirm swal2-styled"
        style="border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214);"
        (click)="acceptButton($event)"
      >
        {{ acceptLabel ? acceptLabel : "Tamam" }}
      </button>
    </div>
  </div>
</dialog>
